export default __webpack_public_path__ + "static/media/nuno.72fa88cd.png";